import { createContext, useContext } from "react";

export const FinancialTenantContext = createContext(false);

let tenantScopedActive = false;

export function setFinancialTenantScopedActive(value) {
  tenantScopedActive = Boolean(value);
}

export function isFinancialTenantScopedActive() {
  return tenantScopedActive;
}

export function useFinancialTenantScoped() {
  return useContext(FinancialTenantContext);
}
